var _desc, _defs, _rect, _rect2, _text, _rect3, _circle, _text2, _rect4, _text3, _path, _rect5, _text4, _text5, _rect6, _text6, _line, _path2, _text7, _text8, _circle2, _text9, _circle3, _text0, _circle4, _text1, _text10, _text11, _rect7, _text12, _line2, _path3, _rect8, _text13, _text14, _text15, _rect9, _text16, _line3, _path4, _text17, _text18, _circle5, _text19, _rect0, _rect1, _rect10, _text20, _text21, _rect11, _text22, _rect12, _text23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpStep1ReportIssue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1293,
    height: 639,
    viewBox: "0 0 1293 639",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Report an issue form example") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A help portal report issue form showing requester, contact method, application service, symptom, detailed description, and submit controls.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "focusGlow",
    x: "-6%",
    y: "-80%",
    width: "112%",
    height: "260%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 4,
    floodColor: "#188ce5",
    floodOpacity: 0.7
  })), /*#__PURE__*/React.createElement("style", null, "\r\n      .label { fill: #34364a; font-family: Arial, sans-serif; font-size: 16px; }\r\n      .field-text { fill: #41444d; font-family: Arial, sans-serif; font-size: 14px; }\r\n      .required { fill: #d93a32; font-family: Arial, sans-serif; font-size: 17px; font-weight: 700; }\r\n      .button-text { fill: #ffffff; font-family: Arial, sans-serif; font-size: 15px; font-weight: 700; }\r\n      .help-pill { fill: #ffffff; font-family: Arial, sans-serif; font-size: 12px; font-weight: 700; }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1293,
    height: 639,
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 948,
    y: 0,
    width: 1,
    height: 639,
    fill: "#e3e5e9"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 19,
    y: 28
  }, "Requester")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 40,
    width: 906,
    height: 38,
    rx: 4,
    fill: "#ffffff",
    stroke: "#9ea1a8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 59,
    r: 7,
    fill: "#383b43"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 37,
    y: 63,
    fill: "#ffffff",
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "i")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 41,
    width: 863,
    height: 36,
    rx: 3,
    fill: "#e3e6ea",
    stroke: "#b7bbc2"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "field-text",
    x: 74,
    y: 65
  }, "Venkataraman P")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M903 58h7l-3.5 5z",
    fill: "#7d8189"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 97,
    width: 17,
    height: 17,
    fill: "#ffffff",
    stroke: "#9ea1a8"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 54,
    y: 111
  }, "Submit Request For Another User")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 19,
    y: 155
  }, "How should your EY Tech Support agent contact you regarding this issue?")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 168,
    width: 906,
    height: 38,
    rx: 4,
    fill: "#ffffff",
    stroke: "#2d8ddf",
    filter: "url(#focusGlow)"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "field-text",
    x: 30,
    y: 193
  }, "Teams Chat")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 890,
    y1: 169,
    x2: 890,
    y2: 205,
    stroke: "#9ea1a8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M905 186h7l-3.5 5z",
    fill: "#7d8189"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "required",
    x: 19,
    y: 240
  }, "*")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 30,
    y: 240,
    fontWeight: 700
  }, "What type of issue are you experiencing?")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 263,
    r: 9,
    fill: "#ffffff",
    stroke: "#4388c9",
    strokeWidth: 5
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 54,
    y: 267
  }, "Application/Service")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 263,
    r: 9,
    fill: "#ffffff",
    stroke: "#9ea1a8"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 253,
    y: 267
  }, "Hardware")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 356,
    cy: 263,
    r: 9,
    fill: "#ffffff",
    stroke: "#9ea1a8"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 379,
    y: 267
  }, "Network Connectivity")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "required",
    x: 19,
    y: 311
  }, "*")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 30,
    y: 311
  }, "Please click to open the drop down and begin typing the application/service name")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 326,
    width: 906,
    height: 37,
    rx: 4,
    fill: "#ffffff",
    stroke: "#9ea1a8"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "field-text",
    x: 30,
    y: 350
  }, "GDS Axon | GDS Axon")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 890,
    y1: 327,
    x2: 890,
    y2: 362,
    stroke: "#9ea1a8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M905 343h7l-3.5 5z",
    fill: "#7d8189"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 383,
    width: 17,
    height: 17,
    fill: "#ffffff",
    stroke: "#9ea1a8"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 54,
    y: 397
  }, "Application/Service not listed")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "required",
    x: 19,
    y: 439
  }, "*")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 30,
    y: 440
  }, "Please select or enter the symptom")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 454,
    width: 906,
    height: 37,
    rx: 4,
    fill: "#ffffff",
    stroke: "#9ea1a8"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "field-text",
    x: 30,
    y: 478
  }, "-- None --")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 890,
    y1: 455,
    x2: 890,
    y2: 490,
    stroke: "#9ea1a8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M905 471h7l-3.5 5z",
    fill: "#7d8189"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "required",
    x: 19,
    y: 522
  }, "*")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 30,
    y: 523
  }, "Detailed Description")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 518,
    r: 8,
    fill: "#c92421"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "help-pill",
    x: 191,
    y: 522
  }, "?")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 537,
    width: 906,
    height: 60,
    rx: 4,
    fill: "#ffffff",
    stroke: "#9ea1a8"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 983,
    y: 7,
    width: 324,
    height: 105,
    rx: 3,
    fill: "#ffffff",
    stroke: "#dde1e6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1006,
    y: 46,
    width: 282,
    height: 39,
    fill: "#191923"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "button-text",
    x: 1121,
    y: 70
  }, "Submit")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 983,
    y: 160
  }, "Required information")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 983,
    y: 172,
    width: 157,
    height: 17,
    rx: 3,
    fill: "#c92421"
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "help-pill",
    x: 990,
    y: 184
  }, "Please select or enter the symptom")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 983,
    y: 196,
    width: 126,
    height: 17,
    rx: 3,
    fill: "#c92421"
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "help-pill",
    x: 990,
    y: 208
  }, "Detailed Description")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpStep1ReportIssue);
export default __webpack_public_path__ + "static/media/help-step-1-report-issue.c49572bf1adfdd87a7a958cded5a790c.svg";
export { ForwardRef as ReactComponent };